import React, { useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { useParams } from 'react-router-dom';

import ClientLinkLayoutComponent from '@/components/ClientLinkLayout/ClientLinkLayoutComponent';
import getUserLanguage from '@/config/language';
import { masksByCountry } from '@/helpers/mask';
import { decodeToken } from '@/helpers/tokenGenerator';
import AddressService from '@/services/addressService';

const ClientLinkLayoutContainer = ({ ...props }) => {
  const { hash } = useParams();
  const franchise = useMemo(() => decodeToken(hash), [hash]);

  // Get language configuration based on franchise country
  const franchiseeCountry = franchise?.country || 'BR';
  const { locale, messages } = getUserLanguage(franchiseeCountry);

  // Get masks and address service based on country
  const masks = masksByCountry[franchiseeCountry];
  const addressService = new AddressService(franchiseeCountry);
  const isBrazilianFranchisee = franchiseeCountry === 'BR' || !franchise?.country;

  return (
    <IntlProvider locale={locale} messages={messages}>
      <ClientLinkLayoutComponent
        franchise={franchise}
        masks={masks}
        addressService={addressService}
        isBrazilianFranchisee={isBrazilianFranchisee}
        franchiseeCountry={franchiseeCountry}
        {...props}
      />
    </IntlProvider>
  );
};

export default ClientLinkLayoutContainer;
